module.exports = __webpack_public_path__ + "static/media/metro3.ce70feb5.jpg";